var chordList = [
  ['C4', 'E4', 'G4', 'B4'],
  ['C4', 'D4', 'F4', 'A4'],
  ['D4', 'E4', 'G4', 'B4'],
  ['C4', 'E4', 'F4', 'A4'],
  ['D4', 'F4', 'G4', 'B4'],
  ['C4', 'E4', 'G4', 'A4'],
  ['D4', 'F4', 'A4', 'B4']
];

export default chordList;




// WEBPACK FOOTER //
// ./src/components/chords/chordList.js